"use client";

import { motion } from "motion/react";
import { Building2, Drone, Globe2, MapPin } from "lucide-react";
import { useFormatter, useTranslations } from "next-intl";

import { HOME_CONFIDENCE_METRICS } from "./statsSectionData";

const icons = [Building2, Drone, MapPin, Globe2] as const;
const colorClass = ["text-blue-600", "text-green-600", "text-purple-600", "text-orange-600"] as const;

export default function StatsSection() {
  const t = useTranslations("Stats");
  const format = useFormatter();

  return (
    <div className="bg-gray-50 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
          {HOME_CONFIDENCE_METRICS.map(({ key, value }, index) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                <div
                  className={`mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg ${colorClass[index]}`}
                >
                  <Icon className="h-8 w-8" />
                </div>
                <div className="mb-2 text-3xl font-bold text-gray-900 lg:text-4xl">{format.number(value)}</div>
                <div className="text-gray-600">{t(`${key}Label`)}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
